import 'core-js/stable';
import 'regenerator-runtime/runtime';
import '@fontsource/raleway/600.css';
import '@fontsource/raleway/500.css';
import '@fontsource/raleway/400.css';
import '@fontsource-variable/ysabeau-office'; // Supports weights 100-900

import '@/fonts/roboto/roboto.css';
import '@/scss/style.css';
import '@/scss/index.scss';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import bootstrap from './bootstrap';

bootstrap(() => void 0);
